import { Data, TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  activationStarted(data: Data) {
    return {
      account_id: data.account_id,
      user: data.user_email,
      product: data.product,
    };
  },

  activationCompleted(data: Data) {
    return {
      account_id: data.account_id,
      user: data.user_email,
      product: data.product,
    };
  },

  activationStepCompleted(data: Data) {
    return {
      product: data.product,
      step: data.step,
      use_case: data.use_case,
      use_case_detail: data.use_case_detail,
      platform: data.platform,
      platform_other: data.platform_other,
      employee_count: data.employee_count,
    };
  },
};

export default Transforms;
